// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accepted-packet-color: #4f81bd;
  --dropped-packet-color: #de392c;
  --forwarded-packet-color: #a8cb60;
}

.pathlookup-tab-content {
  border-right: 1px solid #d6d6d6;
}

.pathlookup-tab-content__severity-info-wrapper {
  width: 180px;
}

.pathlookup-tab-content-row--odd {
  background: #eeeced;
}

.pathlookup-tab-content-cell {
  border-left: 1px solid #d6d6d6;
  border-right: 1px solid #d6d6d6;
  height: 100%;
  padding: 8px 20px;
}

.pathlookup-tab-content-cell--no-padding {
  padding: 0;
}

.pathlookup-tab-content-cell__first {
  border-left: 0;
  padding-left: 0;
}

.pathlookup-tab-content-cell__last {
  border-right: 0;
}

.pathlookup-tab-content-cell__heading {
  border-top: 0;
  border-bottom: 2px solid #d6d6d6;
}

.pathlookup-tab-content-cell__indent {
  min-width: 20px;
  max-width: 20px;
}

.pathlookup-tab-content-event-cell--border {
  border-bottom: 1px solid #d6d6d6;
}

.pathlookup-tab-content-event__color--0 {
  color: var(--severity-color-0);
}

.pathlookup-tab-content-event__color--10 {
  color: var(--severity-color-10);
}

.pathlookup-tab-content-event__color--20 {
  color: var(--severity-color-20);
}

.pathlookup-tab-content-event__color--30 {
  color: var(--severity-color-30);
}

.path-inspector-packet-select__list {
  transition: box-shadow .3s ease-in-out;
  box-shadow: 0 0 20px #0003;
}

.path-inspector-packet-select--hover {
  box-shadow: 0 0 30px #0000004d;
}

.path-inspector-packet-select__highlight-border {
  height: var(--base-sizes-2-5);
  margin-top: var(--base-sizes-2-5);
  position: relative;
}

.path-inspector-packet-select__highlight-border:after {
  height: var(--base-sizes-0);
  content: "";
  background: #6c7e9d;
  transition: height .3s ease-in-out;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.path-inspector-packet-select__highlight-border--hover:after {
  height: var(--base-sizes-2-5);
}

.path-inspector-packet-select:after {
  box-shadow: none;
  content: " ";
  pointer-events: none;
  z-index: 1;
  width: 100%;
  height: 100%;
  transition: box-shadow .5s ease-in-out;
  position: absolute;
  top: 0;
}

.path-inspector-packet-select--shadow:after {
  box-shadow: 0 0 30px #ccc;
}

.path-inspector-packet-select__border {
  height: 1px;
  line-height: 1px;
}

.path-inspector-packet-select__border--forwarded, .path-inspector-packet-select__border--generated {
  background-color: var(--forwarded-packet-color);
}

.path-inspector-packet-select__border--accepted {
  background-color: var(--accepted-packet-color);
}

.path-inspector-packet-select__border--dropped {
  background-color: var(--dropped-packet-color);
}

.pathlookup-select-packets {
  border-left: 1px solid #d6d6d6;
}

.pathlookup-select-packets__node-title {
  border-bottom: 1px solid #d6d6d6;
}

.pathlookup-select-packets__no-terminated-packets {
  color: #787878;
}

.pathlookup-select-packets__step {
  color: #fff;
  text-transform: uppercase;
  background: #323232;
  border-radius: 8px;
  flex-shrink: 0;
  height: 16px;
  padding: 0 9px;
  font-size: 10px;
  font-weight: bold;
  line-height: 16px;
}

.pathlookup-select-packets__tooltip {
  color: #fff;
  text-align: center;
  background: #323232;
  border-radius: 8px;
  width: 12px;
  height: 12px;
  font-size: 12px;
  font-weight: bold;
  line-height: 12px;
  display: inline-block;
}

.pathlookup-select-packets__sort {
  width: 280px;
}

input[type="checkbox"].pathlookup-select-packets__show-packet {
  vertical-align: middle;
  margin-top: 0;
}

.pathlookup-select-packets__show-packet-count {
  color: #fff;
  text-align: center;
  border-radius: 8px;
  min-width: 16px;
  height: 16px;
  font-size: 11px;
  font-weight: bold;
  line-height: 16px;
  display: inline-block;
}

.pathlookup-select-packets__show-packet-count--accepted {
  background-color: var(--accepted-packet-color);
}

.pathlookup-select-packets__show-packet-count--dropped {
  background-color: var(--dropped-packet-color);
}

.pathlookup-select-packets__show-packet-count--forwarded {
  background-color: var(--forwarded-packet-color);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/DeviceView/DeviceViewContent/PathInspector/styles.css","webpack://./services/frontend/app/components/DeviceView/DeviceViewContent/PathInspector/styles.css"],"names":[],"mappings":"AADA;ECEE,gCAAgC;EAChC,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[":root {\n  --accepted-packet-color: #4f81bd;\n  --dropped-packet-color: #de392c;\n  --forwarded-packet-color: #a8cb60;\n}\n\n.pathlookup-tab-content {\n  border-right: 1px solid #d6d6d6;\n}\n\n.pathlookup-tab-content__severity-info-wrapper {\n  width: 180px;\n}\n\n.pathlookup-tab-content-row--odd {\n  background: #eeeced;\n}\n\n.pathlookup-tab-content-cell {\n  border-left: 1px solid #d6d6d6;\n  border-right: 1px solid #d6d6d6;\n  height: 100%;\n  padding: 8px 20px;\n}\n\n.pathlookup-tab-content-cell--no-padding {\n  padding: 0;\n}\n\n.pathlookup-tab-content-cell__first {\n  border-left: 0;\n  padding-left: 0;\n}\n\n.pathlookup-tab-content-cell__last {\n  border-right: 0;\n}\n\n.pathlookup-tab-content-cell__heading {\n  border-bottom: 2px solid #d6d6d6;\n  border-top: 0;\n}\n\n.pathlookup-tab-content-cell__indent {\n  max-width: 20px;\n  min-width: 20px;\n}\n\n.pathlookup-tab-content-event-cell--border {\n  border-bottom: 1px solid #d6d6d6;\n}\n\n.pathlookup-tab-content-event__color--0 {\n  color: var(--severity-color-0);\n}\n\n.pathlookup-tab-content-event__color--10 {\n  color: var(--severity-color-10);\n}\n\n.pathlookup-tab-content-event__color--20 {\n  color: var(--severity-color-20);\n}\n\n.pathlookup-tab-content-event__color--30 {\n  color: var(--severity-color-30);\n}\n\n.path-inspector-packet-select__list {\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  transition: box-shadow 0.3s ease-in-out;\n}\n\n.path-inspector-packet-select--hover {\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);\n}\n\n.path-inspector-packet-select__highlight-border {\n  position: relative;\n  height: var(--base-sizes-2-5);\n  margin-top: var(--base-sizes-2-5);\n}\n\n.path-inspector-packet-select__highlight-border:after {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: var(--base-sizes-0);\n\n    content: '';\n    background: #6c7e9d;\n    transition: height 0.3s ease-in-out;\n}\n\n.path-inspector-packet-select__highlight-border--hover:after {\n  height: var(--base-sizes-2-5);\n}\n\n.path-inspector-packet-select:after {\n    box-shadow: none;\n    content: ' ';\n    height: 100%;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    transition: box-shadow 0.5s ease-in-out;\n    width: 100%;\n    z-index: 1;\n  }\n\n.path-inspector-packet-select--shadow:after {\n    box-shadow: 0 0 30px 0 #ccc;\n  }\n\n.path-inspector-packet-select__border {\n  height: 1px;\n  line-height: 1px;\n}\n\n.path-inspector-packet-select__border--forwarded,\n.path-inspector-packet-select__border--generated {\n  background-color: var(--forwarded-packet-color);\n}\n\n.path-inspector-packet-select__border--accepted {\n  background-color: var(--accepted-packet-color);\n}\n\n.path-inspector-packet-select__border--dropped {\n  background-color: var(--dropped-packet-color);\n}\n\n.pathlookup-select-packets {\n  border-left: 1px solid #d6d6d6;\n}\n\n.pathlookup-select-packets__node-title {\n  border-bottom: 1px solid #d6d6d6;\n}\n\n.pathlookup-select-packets__no-terminated-packets {\n  color: #787878;\n}\n\n.pathlookup-select-packets__step {\n  background: #323232;\n  border-radius: 8px;\n  color: #fff;\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: bold;\n  height: 16px;\n  line-height: 16px;\n  padding: 0 9px;\n  text-transform: uppercase;\n}\n\n.pathlookup-select-packets__tooltip {\n  background: #323232;\n  border-radius: 8px;\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: bold;\n  height: 12px;\n  line-height: 12px;\n  text-align: center;\n  width: 12px;\n}\n\n.pathlookup-select-packets__sort {\n  width: 280px;\n}\n\ninput[type='checkbox'].pathlookup-select-packets__show-packet {\n  margin-top: 0;\n  vertical-align: middle;\n}\n\n.pathlookup-select-packets__show-packet-count {\n  border-radius: 8px;\n  color: #fff;\n  display: inline-block;\n  font-size: 11px;\n  font-weight: bold;\n  height: 16px;\n  line-height: 16px;\n  min-width: 16px;\n  text-align: center;\n}\n\n.pathlookup-select-packets__show-packet-count--accepted {\n  background-color: var(--accepted-packet-color);\n}\n\n.pathlookup-select-packets__show-packet-count--dropped {\n  background-color: var(--dropped-packet-color);\n}\n\n.pathlookup-select-packets__show-packet-count--forwarded {\n  background-color: var(--forwarded-packet-color);\n}\n",":root {\n  --accepted-packet-color: #4f81bd;\n  --dropped-packet-color: #de392c;\n  --forwarded-packet-color: #a8cb60;\n}\n\n.pathlookup-tab-content {\n  border-right: 1px solid #d6d6d6;\n}\n\n.pathlookup-tab-content__severity-info-wrapper {\n  width: 180px;\n}\n\n.pathlookup-tab-content-row--odd {\n  background: #eeeced;\n}\n\n.pathlookup-tab-content-cell {\n  border-left: 1px solid #d6d6d6;\n  border-right: 1px solid #d6d6d6;\n  height: 100%;\n  padding: 8px 20px;\n}\n\n.pathlookup-tab-content-cell--no-padding {\n  padding: 0;\n}\n\n.pathlookup-tab-content-cell__first {\n  border-left: 0;\n  padding-left: 0;\n}\n\n.pathlookup-tab-content-cell__last {\n  border-right: 0;\n}\n\n.pathlookup-tab-content-cell__heading {\n  border-top: 0;\n  border-bottom: 2px solid #d6d6d6;\n}\n\n.pathlookup-tab-content-cell__indent {\n  min-width: 20px;\n  max-width: 20px;\n}\n\n.pathlookup-tab-content-event-cell--border {\n  border-bottom: 1px solid #d6d6d6;\n}\n\n.pathlookup-tab-content-event__color--0 {\n  color: var(--severity-color-0);\n}\n\n.pathlookup-tab-content-event__color--10 {\n  color: var(--severity-color-10);\n}\n\n.pathlookup-tab-content-event__color--20 {\n  color: var(--severity-color-20);\n}\n\n.pathlookup-tab-content-event__color--30 {\n  color: var(--severity-color-30);\n}\n\n.path-inspector-packet-select__list {\n  transition: box-shadow .3s ease-in-out;\n  box-shadow: 0 0 20px #0003;\n}\n\n.path-inspector-packet-select--hover {\n  box-shadow: 0 0 30px #0000004d;\n}\n\n.path-inspector-packet-select__highlight-border {\n  height: var(--base-sizes-2-5);\n  margin-top: var(--base-sizes-2-5);\n  position: relative;\n}\n\n.path-inspector-packet-select__highlight-border:after {\n  height: var(--base-sizes-0);\n  content: \"\";\n  background: #6c7e9d;\n  transition: height .3s ease-in-out;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.path-inspector-packet-select__highlight-border--hover:after {\n  height: var(--base-sizes-2-5);\n}\n\n.path-inspector-packet-select:after {\n  box-shadow: none;\n  content: \" \";\n  pointer-events: none;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  transition: box-shadow .5s ease-in-out;\n  position: absolute;\n  top: 0;\n}\n\n.path-inspector-packet-select--shadow:after {\n  box-shadow: 0 0 30px #ccc;\n}\n\n.path-inspector-packet-select__border {\n  height: 1px;\n  line-height: 1px;\n}\n\n.path-inspector-packet-select__border--forwarded, .path-inspector-packet-select__border--generated {\n  background-color: var(--forwarded-packet-color);\n}\n\n.path-inspector-packet-select__border--accepted {\n  background-color: var(--accepted-packet-color);\n}\n\n.path-inspector-packet-select__border--dropped {\n  background-color: var(--dropped-packet-color);\n}\n\n.pathlookup-select-packets {\n  border-left: 1px solid #d6d6d6;\n}\n\n.pathlookup-select-packets__node-title {\n  border-bottom: 1px solid #d6d6d6;\n}\n\n.pathlookup-select-packets__no-terminated-packets {\n  color: #787878;\n}\n\n.pathlookup-select-packets__step {\n  color: #fff;\n  text-transform: uppercase;\n  background: #323232;\n  border-radius: 8px;\n  flex-shrink: 0;\n  height: 16px;\n  padding: 0 9px;\n  font-size: 10px;\n  font-weight: bold;\n  line-height: 16px;\n}\n\n.pathlookup-select-packets__tooltip {\n  color: #fff;\n  text-align: center;\n  background: #323232;\n  border-radius: 8px;\n  width: 12px;\n  height: 12px;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  display: inline-block;\n}\n\n.pathlookup-select-packets__sort {\n  width: 280px;\n}\n\ninput[type=\"checkbox\"].pathlookup-select-packets__show-packet {\n  vertical-align: middle;\n  margin-top: 0;\n}\n\n.pathlookup-select-packets__show-packet-count {\n  color: #fff;\n  text-align: center;\n  border-radius: 8px;\n  min-width: 16px;\n  height: 16px;\n  font-size: 11px;\n  font-weight: bold;\n  line-height: 16px;\n  display: inline-block;\n}\n\n.pathlookup-select-packets__show-packet-count--accepted {\n  background-color: var(--accepted-packet-color);\n}\n\n.pathlookup-select-packets__show-packet-count--dropped {\n  background-color: var(--dropped-packet-color);\n}\n\n.pathlookup-select-packets__show-packet-count--forwarded {\n  background-color: var(--forwarded-packet-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
